import { Box } from '@mui/material'
import { RoutingInfoStore } from '@storage/stores/routing-info.store'
import { useTolgee } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import LocationInfo from './LocationInfo'

interface Props {
  dropOffContainers: {
    containerNumber: string
    linkedOrderArrivedOrInOperationVisitName: string | undefined
  }[]
  routingInfoStore: RoutingInfoStore
  allowDirectDelivery: boolean
}

const ContainerDropOffInfo = observer(
  ({ dropOffContainers, routingInfoStore, allowDirectDelivery }: Props) => {
    const { t } = useTolgee()

    useEffect(() => {
      const loadDropOffInfo = async () => {
        await routingInfoStore.fetchDropOffInfo(dropOffContainers.map(c => c.containerNumber))
      }
      loadDropOffInfo()
    }, [dropOffContainers, routingInfoStore])

    return (
      <Box>
        {routingInfoStore.dropOffInfo.length > 0 &&
          routingInfoStore.dropOffInfo.map(info => {
            const linkedOrderArrivedOrInOperationVisitName = dropOffContainers.find(
              c => c.containerNumber === info.containerNumber,
            )?.linkedOrderArrivedOrInOperationVisitName
            if (allowDirectDelivery && linkedOrderArrivedOrInOperationVisitName) {
              info.blockName = `${linkedOrderArrivedOrInOperationVisitName}${info.blockName ? '\n(' + info.blockName + ')' : ''}`
            }
            if (!info.blockName) {
              routingInfoStore.incrementWarnings()
            }
            return (
              <Box key={info.containerNumber} sx={{ marginBottom: '16px' }}>
                <LocationInfo
                  key={info.containerNumber}
                  blockName={info.blockName ?? t('noLocation', 'No Location')}
                  containerNumber={info.containerNumber}
                  action={'Drop off'}
                />
              </Box>
            )
          })}
      </Box>
    )
  },
)

export default ContainerDropOffInfo
